import React from "react";
import {styled,Paper} from '@mui/material';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import RandomImages from "./RandomImages";
import GoldBox from "./GoldBox";
import { Masthead as MastheadProps } from "../../types/app";

const ROTATE_INTERVAL   = 30000;
const CLIP_SPACING      = 6;

const Root = styled(Box)({
    position        : 'relative', 
    overflow        : 'hidden'
})

const TextOverlay = styled(Paper)(({ theme}) => ({
    margin          : theme.spacing(8),
    borderRadius    : theme.spacing(1),
    position        : 'absolute',
    overflow        : 'hidden',
    bottom          : 0,
    right           : 0,
    width           : '40%', // Occupy bottom-right quadrant
    backgroundColor : 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
    color           : theme.palette.common.white,
    borderColor     : theme.palette.common.white,
    padding         : 0,
    boxSizing       : 'border-box',
    textAlign       : 'left',
    [theme.breakpoints.up('xs')]: {
        width       : '70%', // Occupy bottom-right quadrant
        margin      : theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
        width       : '60%', // Occupy bottom-right quadrant
        margin      : theme.spacing(4),
    },
    [theme.breakpoints.up('md')]: {
        width       : '50%', // Occupy bottom-right quadrant
        margin      : theme.spacing(6),
    },
    [theme.breakpoints.up('lg')]: {
        width       : '40%', // Occupy bottom-right quadrant
        margin      : theme.spacing(8),
    },
}));

const TitleTypography = styled(Typography)(({theme}) => ({
    color           : 'inherit',
    fontWeight      : 800,
    fontSize        : '1.5rem',
    marginBottom    : 0,
    marginTop       : 0,
    [theme.breakpoints.up('xs')]: {
        fontSize    : '1.5rem',
    },
    [theme.breakpoints.up('sm')]: {
        fontSize    : '1.5rem',
    },
    [theme.breakpoints.up('md')]: {
        fontSize    : '2rem',
    },
    [theme.breakpoints.up('lg')]: {
        fontSize    : '2.5rem',
    },
}));

const TaglineTypography = styled(Typography)(({theme}) => ({
    color           :'inherit',
    textAlign       :'right',
    fontWeight      : 100,
    fontSize        : '1rem',
    [theme.breakpoints.up('xs')]: {
        fontSize    : '1rem',
    },
    [theme.breakpoints.up('sm')]: {
        fontSize    : '1rem',
    },
    [theme.breakpoints.up('md')]: {
        fontSize    : '1.25rem',
    },
    [theme.breakpoints.up('lg')]: {
        fontSize    : '1.50rem',
    },
}));

const TitleBox = styled(Box)(({theme}) => ({
    padding         : theme.spacing(3),
    paddingBottom   : 0
}));

const SlantedGoldBox = styled(GoldBox)(({theme}) => ({
    padding         : theme.spacing(2),
    paddingTop      : theme.spacing(CLIP_SPACING),
    borderTop       : '5px solid inherit', 
    color           : theme.palette.primary.contrastText,
    clipPath        : `polygon(
        0 ${theme.spacing(CLIP_SPACING)}, 
        100% 0, 
        100% 100%, 
        0 100%
    )`
}));

export const MastHead : React.FC<MastheadProps> = ({contentful_id, heading, tagline, imageSet}) => {
    return (
        <Root>
            <RandomImages seed={contentful_id} imageSet={imageSet} interval={ROTATE_INTERVAL} count={1} xs={12} imageContainerProps={{style:{aspectRatio: '2.5'}}} directory="masthead"/>
            <TextOverlay elevation={4} sx={{}}>
                <TitleBox>
                    <TitleTypography data-sb-field-path="heading" variant="h1">
                        {heading}
                    </TitleTypography>
                </TitleBox>
                <SlantedGoldBox>
                    <TaglineTypography data-sb-field-path="tagline">
                        {tagline}
                    </TaglineTypography>
                </SlantedGoldBox>
            </TextOverlay>
            {false && JSON.stringify(imageSet,null,4)}
        </Root>
    )
}

export default MastHead;